//@formatter:off
/**
 * @ngdoc filter
 * @name decimal2comma
 * @module portaro.filters
 * @kind function
 *
 * @param {number|string} input Input
 *
 * @return {string} Formatted number
 *
 * @description
 * Filter converts given input to comma-separated formatted `string` output. If decimal count is 1, filter appends '0' on the end, for better readability.
 *
 * @example
 * <example module="decimal2commaFilterExample" name="decimal2commaFilterExample" frame-no-resize="true">
    <file name="index.html">
        <main>
            <div>
                <label for="input">Input value: </label>
                <input id="input" type="text" ng-model="input">
            </div>
            <div>
                Output: {{input | decimal2comma}}
            </div>
        </main>
    </file>
    <file name="script.js">
        angular.module('decimal2commaFilterExample', ['portaro.filters']);
    </file>
 * </example>
 */
 //@formatter:on
export default function decimal2commaFilter() {
    return (input) => {
        let ret = input || input === 0 ? input.toString().replace('.', ',') : null;
        if (ret) {
            const decArr = ret.split(',');
            if (decArr.length > 1) {
                const dec = decArr[1].length;
                if (dec === 1) {
                    ret += '0';
                }
            }//this is to show prices like 12,20 and not 12,2
        }
        return ret;
    };
}

decimal2commaFilter.filterName = 'decimal2comma';